module.exports = __webpack_public_path__ + "img/1-detail.54a7714c.jpg";